// extracted by mini-css-extract-plugin
module.exports = {"img":"index-module--img--2kB_9","gatsbyImg":"index-module--gatsbyImg--3h-ee","caption":"index-module--caption--i2dNi"};